import { render, staticRenderFns } from "./ModalDetallesSolicitudesPagos.vue?vue&type=template&id=264b8f26"
import script from "./ModalDetallesSolicitudesPagos.vue?vue&type=script&lang=js"
export * from "./ModalDetallesSolicitudesPagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports